module Meevo.Plugins.Client {

    import ISelectItem = Meevo.Model.ISelectItem;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;

    const ACCOUNT_TYPES_VERBOSE = {
        [SalesTypeEnum.ClientAccountPayment]: 'LABEL_PAYMENT',
        [SalesTypeEnum.ClientAccountCredit]: 'LABEL_CREDIT',
        [SalesTypeEnum.DepositCredit]: 'LABEL_CLIENT_DEPOSIT_PAYMENT',
    };

    const PRESET_LIST = [
        {name: 'LABEL_CUSTOM', status: PresetStatus.Custom},
        {name: 'LABEL_TODAY', status: PresetStatus.Today},
        {name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday},
        {name: 'LABEL_TOMORROW', status: PresetStatus.Tomorrow},
        {name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
        {name: 'LABEL_LAST_SEVEN_DAYS', status: PresetStatus.LastSevenDays},
        {name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek},
        {name: 'LABEL_NEXT_WEEK', status: PresetStatus.NextWeek},
        {name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks},
        {name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth},
        {name: 'LABEL_LAST_THIRTY_DAYS', status: PresetStatus.LastThirtyDays},
        {name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth},
        {name: 'LABEL_NEXT_MONTH', status: PresetStatus.NextMonth},
        {name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter},
        {name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter},
        {name: 'LABEL_NEXT_QUARTER', status: PresetStatus.NextQuarter},
        {name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear},
        {name: 'LABEL_LAST_TWELVE_MONTHS', status: PresetStatus.LastTwelveMonthsIncludingToday},
        {name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear},
        {name: 'LABEL_NEXT_YEAR', status: PresetStatus.NextYear},
        {name: 'LABEL_YEAR_TO_DATE', status: PresetStatus.YearToDate}
    ];

    class AccountHistoryCriteria implements IAccountHistoryCriteria {
        Client_TId: string;
        StartDateTime?: Date;
        EndDateTime?: Date;
        ItemType?: AccountHistoryItemType;
        LocationId?: number;
        isVoided?: boolean;
        IsForCO?: boolean;

        constructor(params: AccountHistoryCriteria = <AccountHistoryCriteria>{}) {
            _.assign(this, params);
        }

        get() {
            this.IsForCO = null;
            if (!this.LocationId) {
                this.IsForCO = true;
                return _.pick(this,
                    'Client_TId',
                    'StartDateTime',
                    'EndDateTime',
                    'ItemType',
                    'IsForCO',
                )
			}
            return _.pick(this,
                'Client_TId',
                'StartDateTime',
                'EndDateTime',
                'ItemType',
                'LocationId',
            )
        }
    }

    class MeevoClientHistoryAccountActivityComponent implements ng.IComponentController {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.plugins.client.ClientApiService',
            '$scope',
            'meevo.components.busy.BusyService',
            '$q',
            'meevo.components.common.IdentityService'
        ];

        public accountHistory: IClientAccountHistory[] = [];
        public locations: Array<Location>;
        public itemTypes: ISelectItem<AccountHistoryItemType>[];
        public criteria: AccountHistoryCriteria;

        public existingBalance: number = 0;
        public existingCreditBalance: number = 0;

        public presetStatus: PresetStatus = PresetStatus.LastTwelveMonthsIncludingToday;
        public presetList = PRESET_LIST;
        public selectedPreset = this.presetList.find(preset => preset.status === this.presetStatus);
        public clientId: string;
        public openTransactionEditorCallback: (item: { transactionNumber: string; locationId: number; }) => void;
        public hideMobileFilters: boolean;
        public currentLocationId: number;
        public isFilterExpanded: boolean;
        public filterDescription: any[];
        public onApplyFilter: (criteria: { criteria: IAccountHistoryCriteria }) => void;
        public topIndex:number ;
        public searchResults: any;
        public activityAttribute: { topIndex: number } = ({ topIndex: 0 });
        public getListHeight:()=>void;
        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
                    private clientApiService: ClientApiService,
                    protected $scope: angular.IScope,
                    private busyService: Meevo.Components.Busy.IBusyService,
                    private $q: ng.IQService,
                    private identityService: Meevo.Components.Common.IIdentityService) {
            this.itemTypes = [
                {value: AccountHistoryItemType.Charge, label: 'LABEL_CLIENT_ACCOUNT_PAYMENT'},
                {value: AccountHistoryItemType.Payment, label: 'LABEL_PAYMENT'},
                {value: AccountHistoryItemType.Credit, label: 'LABEL_CREDIT'},
                {value: AccountHistoryItemType.DepositPayment, label: 'LABEL_CLIENT_DEPOSIT_PAYMENT'},
                {value: AccountHistoryItemType.DepositCharge, label: 'LABEL_CLIENT_DEPOSIT_CHARGE'}
            ]
            this.currentLocationId = this.identityService.current().locationId;
            

            this.getListHeight = function () {
                //console.log('window.innerHeight', window.innerHeight);
                if ($scope.isMobileDevice) {
                    return { height:  '70vh' };
                }
                else {
                    return { height: '40vh' };
                }
                //return { height: '' + (window.innerHeight - 10) + 'vh' };
            };
            window.addEventListener('resize', onResize);
            function onResize() {
                $scope.$digest();
            }
            $scope.$on('$destroy', function () {
                window.removeEventListener('resize', onResize);
            });


        }

        getItemSize() {
            if (this.$scope.isMobileDevice) {
                return 10;
            }
            else {
                return 30;
            }
        }
    


        $onInit() {
            this.criteria = new AccountHistoryCriteria(<AccountHistoryCriteria>{
                Client_TId: this.clientId,
                LocationId: this.currentLocationId,
                ItemType: null,
                StartDateTime: moment().startOf('day').toDate(),
                EndDateTime: moment().endOf('day').toDate()
            });

            this.loadLocations().then(() => {
                this.loadExistingCounts();
                //this.loadDataAccountHistory();
                this.getSearchResults();
            });
            
        }
       
        applyFilter() {
            this.getSearchResults();
           // this.loadDataAccountHistory();
            this.isFilterExpanded = false;
        }
        getSearchResults() {
            this.busyService.start();
            if (this.onApplyFilter) {
                this.onApplyFilter({ criteria: this.criteria });
            }
            var uri = `Client/${this.clientId}/AccountHistory`;

            this.searchResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, uri);
            // Prepare request
            let request = {
                pageNumber: 1,
                itemsPerPage: 30,
                criteria: this.criteria,
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };

            // Execute request into ties
            this.searchResults.initSearch(request);
            //console.log('this.searchResults', this.searchResults);
            this.busyService.stop();
        }

        loadDataAccountHistory(): ng.IPromise<any> {
            this.busyService.start();
            this.loadExistingCounts();
            //this.$scope.$watch("$parent.$parent.$parent.$parent.context.selectedSection.hideMobileFilters", hideMobileFilters => {
            //    this.hideMobileFilters = hideMobileFilters;
            //});

            if (this.onApplyFilter) {
                this.onApplyFilter({ criteria: this.criteria });
            }

            return this.clientApiService.getAccountHistory(this.clientId, this.criteria.get())
                .then(data => this.accountHistory = data)
                .finally(() => {
                    this.busyService.stop();
                });
        }

        loadExistingCounts() {
            this.clientApiService.getAccountHistoryExistingBalance(this.clientId, this.criteria.get())
                .then((data: ITotalAmountBySaleType) => {
                    this.existingCreditBalance = data.accountBalance;
                });
        }

        updateLocationId(locationId) {
            this.currentLocationId = locationId;
        }

        loadLocations() {
            return this.dataService.customMethodData('api/location/list', 'POST', {
                criteria: {
                    filterBySessionUser: true,
                    zipCode: '',
                    locationStatus: [30188, 30189, 30190, 30191], // Active, TemporarilyClosed, ClosingPlanned, Closed
                    subscriptionStatus: [1840, 1841, 1842, 1843, 1844, 1845, 30187, 30258] // Active, Frozen, Suspended, Cancelled, Terminated, Inactive, Pending, Upgrading
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
                itemsPerPage: 100000,
                pageNumber: 0,
                sortBy: '',
                sortDirection: Meevo.Model.SortDirection.Ascending
            }).then((response) => {
                this.locations = response.data;
            }).finally(() => {
                this.busyService.stop();
            });
        }

        openTransactionEditor(item: IClientAccountHistory) {
            this.openTransactionEditorCallback(item);
        }

        getItemTypeVerbose(itemType: SalesTypeEnum): string {
            return ACCOUNT_TYPES_VERBOSE[itemType] || 'LABEL_FILTER_CANCELLED_WITH_CHARGE';
        }

        resetFilter() {
            this.criteria.ItemType = null;
            this.criteria.LocationId = null;
            this.criteria.StartDateTime = moment().startOf('day').toDate();
            this.criteria.EndDateTime = moment().endOf('day').toDate();
            this.presetStatus = PresetStatus.Today;
            this.selectedPreset = this.presetList.find(preset => preset.status === this.presetStatus);
            this.loadDataAccountHistory();
            this.loadExistingCounts();
        }
    }

    angular.module('meevo.plugins.client')
        .component('meevoClientHistoryAccountActivityComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/client/components/client-history-account-activity/client-history-account-activity.component.html',
            controller: MeevoClientHistoryAccountActivityComponent,
            controllerAs: '$ctrl',
            bindings: {
                activityAttribute:'=',
                clientId: '<',
                openTransactionEditorCallback: '&',
                isFilterExpanded: '=',
                hideMobileFilters: '=',
                filterDescription: '=',                
                onApplyFilter: '&',
     
            }
        });
}
